import styled from "styled-components";

export const Container = styled.div`
    padding: 14px;
    margin-bottom:10px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #e377e6;
    border-radius: 4px;
    box-shadow: 0 6px 20px 0 rgba(0,0,0,0.1);
`;

export const QuestionTextContainer = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 10px;
`;

export const QuestionLabelContainer = styled.div`
    background-color: #652278;
    color: #ffffff;
    padding: 4px 8px;
    border-radius: 4px;
    margin-right: 10px;
`;

export const QuestionLabel = styled.span`
    font-weight: 700;
    font-size: 14px;
`;

export const Question = styled.span`
    font-weight: 600;
    font-size: 16px;
    flex: 1;
`;

export const InfoIconContainer = styled.div`
    cursor: pointer;
    margin-left: 10px;
`;

export const MainContainer = styled.div`
    margin: 10px 0;
`;

export const AnswerContainer = styled.div`
    display: flex;
    gap: 10px;
    margin-top: 10px;
    width: 100%;
`;

export const AnswerIconContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px solid #ccc;
    border-radius: 8px;
    padding: 10px;
    cursor: pointer;
    flex: 1;
    transition: all 0.2s ease;
    ${({ styleAttributes }) => styleAttributes && { ...styleAttributes }}
    ${({ disabled }) => disabled && `
        cursor: not-allowed;
        opacity: 0.6;
    `}
`;

export const AnswerIcon = styled.img`
    width: 30px;
    height: 30px;
    margin-bottom: 5px;
`;

export const Answer = styled.span`
    font-size: 12px;
    font-weight: 700;
`;